var en = {
    translation: {
        button: {
            back: 'Back',
            backToAccountServices: 'BACK TO ACCOUNT SERVICES',
            cancel: 'CANCEL',
            changeDueDate: 'Change Due Date',
            close: 'CLOSE',
            creditLimitIncrease: 'Credit Limit Increase',
            requestIncrease: 'REQUEST INCREASE',
            submit: 'Submit'
        },
        changePaymentDueDate: {
            changePaymentDueDate: 'Change payment due date',
            modalHeader: 'Change Due Date'
        },
        cliBusinessError: {
            subTitle: 'You will receive a letter in 7-10 business days explaining the reason for our decision.',
            title: 'Your credit limit cannot be increased at this time'
        },
        cliPartialSuccess: {
            subTitle: 'We are unable to grant the full amount that you requested. However, we were able to increase your credit limit. You will receive a letter in 7-10 business days explaining the reason for our decision.'
        },
        cliPendingReferral: {
            subTitle: 'We are reviewing your request. You will receive a letter in 7-10 business days with your request decision.',
            title: 'Your credit limit request is pending'
        },
        cliSuccess: {
            newLimit: 'NEW CREDIT LIMIT',
            subText: 'Your credit limit is available for immediate use.',
            subTitle: 'Your request for a credit limit increase has been approved for the following:',
            title: 'We increased your credit limit'
        },
        errorMessages: {
            accessDeniedMessageBox: {
                body: 'Please call (800) 508-2520 for assistance. We’re always available to help, call us 24/7.',
                title: 'We’re having trouble verifying your identity'
            },
            addPrimaryHolder: {
                extraInfo: 'Try again with another name.',
                subTitle: 'You entered the name of the Primary Cardholder who already has a card.',
                title: 'Please try again'
            },
            addressChanged: 'We cannot process your request since your address was changed in the last 30 days.',
            dueDateChangePeriodRestriction: {
                subTitle: 'You can change your due date once every 12 months.',
                title: 'You can’t change your due date right now'
            },
            nameChanged: 'We cannot process your request since your first name was changed in the last 30 days.',
            notEligible: {
                body: 'We cannot process your request for Change Due Date at this time.',
                title: 'Your account is not eligible'
            },
            notEligibleAccount: 'Your account is not eligible',
            profanity: {
                title: 'Please try again',
                unapprovedName: 'The name(s) you gave us couldn’t be accepted as entered. Please make any corrections and try again.'
            },
            troubleAccessingAccount: 'We’re having trouble accessing your account',
            troubleRetrievingInformation: 'We’re having trouble retrieving your information',
            tryAgainLater: 'Please try again later.',
            unableToProcessRequest: 'Unfortunately we are unable to process your request at this time. Please try again later.'
        },
        mocks: {
            accountEnding: 'Account ending in {{accountLast4}}',
            availableToSpend: 'Available to spend',
            beginLogin: 'Begin Login',
            cardAccountEnding: 'Card for account ending in {{accountLast4}}',
            clientId: 'Enter a Client ID',
            currentBalance: 'Current Balance',
            environment: 'Choose an Environment',
            logout: 'Logout',
            makeAPayment: 'Make a Payment',
            paymentDueDate: 'Payment Due Date',
            totalMinimumPayment: 'Total Minimum Payment'
        },
        modal: {
            annualNetIncome: 'Annual Net Income',
            annualNetIncomeHelperText: 'Include income from sources after taxes',
            annualNetIncomeInputErrorText: 'Enter income including sources after taxes',
            cliRequest: 'Request a credit limit increase',
            closeDialog: 'Close Dialog',
            creditLimit: "{{creditLimit}}",
            currentCreditLimit: 'CURRENT CREDIT LIMIT',
            desiredIncreaseInputErrorText: 'Enter the desired credit limit you want to request',
            desiredLimit: 'Desired Limit',
            desiredLimitHelperText: 'Enter the total credit limit you want to request',
            header: 'Credit Limit Increase',
            increaseLimitByMore: 'New desired limit must be at least $50 greater than current credit limit',
            maxCreditLimit: 'You cannot request a credit limit of more than $99,999.00',
            tooltipLabelButton: 'How does it impact my credit score?',
            tooltipMessage: 'We will not obtain a credit bureau report to evaluate your request and you will receive a decision instantly.'
        },
        text: {
            accountActions: 'Account Actions',
            accountServices: 'Account Services',
            address: 'Address',
            amount: 'Amount',
            autoPay: 'Auto Pay',
            cardManagement: 'Card Management',
            enrollmentOpportunities: 'Enrollment Opportunities',
            legalText: "Your \u201CNet Income\u201D includes what you earn or reasonably expect to earn\n      from employment, investments, retirement, social security benefits and\n      public assistance. You can also include money that someone else\n      deposits regularly into your account (individual or joint) and the\n      amount that you have available to spend from your assets. If you are\n      21 or over, you may also include the amount of someone else\u2019s income\n      that is regularly used to pay your expenses. Alimony, child support or\n      separate maintenance income need not be included unless relied upon\n      for credit. WI Residents Only: If this is an individual account,\n      please also include your spouse\u2019s income.",
            manageCardHolders: 'Manage cardholders',
            paymentSecurity: 'Payment Security'
        }
    }
};
export default en;
